import { z } from "zod";
import { EnreinArtifactUriSchema } from "./artifact-uri.js";
/** AR-004 — immutable approved-artifact history index (append-only). */
export const ApprovedArtifactHistoryEntryV1Schema = z
    .object({
    entryId: z.string().min(1),
    artifactUri: EnreinArtifactUriSchema,
    approvedAt: z.string().datetime(),
    integrityRef: z.string().min(1),
})
    .strict();
export const ApprovedArtifactHistoryIndexV1Schema = z
    .object({
    schemaVersion: z.literal("approved-artifact-history.v1.0"),
    entries: z.array(ApprovedArtifactHistoryEntryV1Schema),
})
    .strict();
export function createEmptyApprovedArtifactHistoryIndex() {
    return ApprovedArtifactHistoryIndexV1Schema.parse({
        schemaVersion: "approved-artifact-history.v1.0",
        entries: [],
    });
}
export function appendApprovedArtifactHistoryEntry(index, entry) {
    const parsedEntry = ApprovedArtifactHistoryEntryV1Schema.parse(entry);
    const parsedIndex = ApprovedArtifactHistoryIndexV1Schema.parse(index);
    if (parsedIndex.entries.some((row) => row.entryId === parsedEntry.entryId)) {
        throw new Error("Approved artifact history entryId must not be overwritten");
    }
    return ApprovedArtifactHistoryIndexV1Schema.parse({
        schemaVersion: parsedIndex.schemaVersion,
        entries: [...parsedIndex.entries, parsedEntry],
    });
}
export function getApprovedArtifactHistoryEntry(index, entryId) {
    const parsed = ApprovedArtifactHistoryIndexV1Schema.parse(index);
    return parsed.entries.find((row) => row.entryId === entryId) ?? null;
}
//# sourceMappingURL=artifact-registry-history.js.map